import { PagesCommonProps } from './pagesUtil';
import { pageFilterOptionsDefaultState } from '../consts/graphs';

/**
 * Filters out filter values that are not applicable to the current page
 * Only keeps filters that are in the validFilterNames list
 * Also always keeps certain system filters like date ranges, lastSyncedDate, etc.
 * 
 * @param filters - The full filters object
 * @param validFilterNames - Array of filter names that are valid for the current page
 * @returns Filtered filters object with only valid filters
 */
export const filterFiltersByPage = (
  filters: PagesCommonProps["filters"],
  validFilterNames: string[]
): PagesCommonProps["filters"] => {
  const systemFilters = [
    //'lastSyncedDate',
    'withCourses',
    'orgsWithCredits',
    'completedCourses',
    'mostCompletedUser',
  ];

  const validFilterSet = new Set([...validFilterNames, ...systemFilters]);

  const filteredFilters: PagesCommonProps["filters"] = { ...pageFilterOptionsDefaultState };

  Object.keys(filters).forEach((key) => {
    if (validFilterSet.has(key)) {
      filteredFilters[key] = filters[key];
    }
  });

  return filteredFilters;
};

